import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import HubIcon from '@mui/icons-material/Hub';

import PlansPanel from './PlansPanel';
import SegmentPlansPanel from './SegmentPlansPanel';

// PlansTabs — wraps the Plans top-level tab with two inner tabs:
// "Optimize Plans" (analyser/snapshot apply runs) and "Segment Plans"
// (long-lived offline-capable segment rollouts). Keeps the two plan
// families visually separate as requested.

const PlansTabs = ({ isActive = true, initialPlanId, onClearInitialPlan, onOpenPlan, allowPlanDelete }) => {
  const [inner, setInner] = useState('optimize');

  // Jumping to a specific optimize plan (e.g. from the optimize tab)
  // should focus the Optimize Plans inner tab.
  useEffect(() => {
    if (initialPlanId) setInner('optimize');
  }, [initialPlanId]);

  return (
    <Box>
      <Tabs
        value={inner}
        onChange={(_e, v) => setInner(v)}
        sx={{ minHeight: 40, mb: 1 }}
      >
        <Tab
          value="optimize"
          icon={<TimelineIcon fontSize="small" />}
          iconPosition="start"
          label="Optimize Plans"
          sx={{ minHeight: 40, textTransform: 'none' }}
        />
        <Tab
          value="segment"
          icon={<HubIcon fontSize="small" />}
          iconPosition="start"
          label="Segment Plans"
          sx={{ minHeight: 40, textTransform: 'none' }}
        />
      </Tabs>

      <Box sx={{ display: inner === 'optimize' ? 'block' : 'none' }}>
        <PlansPanel
          isActive={isActive && inner === 'optimize'}
          initialPlanId={initialPlanId}
          onClearInitialPlan={onClearInitialPlan}
          onOpenPlan={onOpenPlan}
          allowPlanDelete={allowPlanDelete}
        />
      </Box>
      <Box sx={{ display: inner === 'segment' ? 'block' : 'none' }}>
        <SegmentPlansPanel
          isActive={isActive && inner === 'segment'}
          allowCancel={allowPlanDelete}
        />
      </Box>
    </Box>
  );
};

export default PlansTabs;
